import androidx.compose.ui.ExperimentalComposeUiApi
import navigation.AppWindow
import org.jetbrains.skiko.wasm.onWasmReady


@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        BrowserViewportWindow("Friendly") {
            AppWindow()
        }
    }
}

